<!-- <app-menu
  [menuId]="'main-content'"
  [items]="[
    { label: 'Dashboard', route: '/dashboard', icon: 'assets/icons/dashboard.svg', active: true },
    { label: 'Orders', route: '/orders', icon: 'assets/icons/orders.svg' },
    { label: 'Settings', route: '/settings', icon: 'assets/icons/settings.svg' }
  ]"
  (itemSelected)="navigate($event)">
</app-menu> -->

<ion-app>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
